import { render } from "./InformeRentabilidadGlobalFacturacion.vue?vue&type=template&id=7bda1362&scoped=true"
import script from "./InformeRentabilidadGlobalFacturacion.vue?vue&type=script&lang=js"
export * from "./InformeRentabilidadGlobalFacturacion.vue?vue&type=script&lang=js"

import "./InformeRentabilidadGlobalFacturacion.vue?vue&type=style&index=0&id=7bda1362&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bda1362"]])

export default __exports__